import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";

export const HomepageSection = ({ form, setField, products }) => {
  const featured = form.featured_product_ids || [];
  const toggle = (id) =>
    setField("featured_product_ids", featured.includes(id) ? featured.filter((x) => x !== id) : [...featured, id].slice(0, 8));

  return (
    <div className="space-y-6">
      <div>
        <Label htmlFor="announcement">Offer / Announcement Bar</Label>
        <Input
          id="announcement"
          value={form.announcement || ""}
          onChange={(e) => setField("announcement", e.target.value)}
          placeholder="e.g. Flat 20% off this weekend | Free delivery above ₹499"
          className="mt-2"
          maxLength={140}
          data-testid="store-announcement-input"
        />
      </div>
      <div>
        <Label htmlFor="about_text">About Section (shown on store homepage)</Label>
        <Textarea
          id="about_text"
          value={form.about_text || ""}
          onChange={(e) => setField("about_text", e.target.value)}
          placeholder="Share your story, quality promise, or what makes your store special..."
          rows={4}
          className="mt-2"
          data-testid="store-about-input"
        />
      </div>
      <div>
        <Label>Featured Products (up to 8)</Label>
        {products.length === 0 ? (
          <p className="text-sm text-gray-500 mt-2">Add products first to feature them on your store homepage.</p>
        ) : (
          <div className="grid sm:grid-cols-2 gap-2 mt-2 max-h-72 overflow-y-auto">
            {products.map((p) => (
              <label key={p.id} className="flex items-center gap-3 p-3 rounded-xl border border-gray-100 hover:bg-gray-50 cursor-pointer">
                <Checkbox
                  checked={featured.includes(p.id)}
                  onCheckedChange={() => toggle(p.id)}
                  data-testid={`featured-product-checkbox-${p.id}`}
                />
                {p.images?.[0] && <img src={p.images[0]} alt="" className="w-10 h-10 rounded-lg object-cover" />}
                <span className="text-sm text-gray-800 line-clamp-1">{p.name}</span>
              </label>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
